<template>
  <div
    class="circle"
    :class="[
      { 'circle--dark-gray': task.status == 'available' },
      { 'circle--active': task.status == 'approved' },
      { 'circle--danger': task.status == 'revision-needed' },
      { 'circle--warning': task.status == 'pending-review' },
      { 'circle--exported': task.status == 'exported' },
    ]"
  ></div>
</template>

<script>
export default {
  props: {
    task: Object,
  },
}
</script>

<style lang="scss" scoped>
.circle {
  height: 10px;
  width: 10px;
  background-color: #d4d4db;
  border-radius: 50%;
  margin-right: 0.25rem;
}
.circle--dark-gray {
  background-color: #999;
}
.circle--active {
  background-color: #4adb91;
}
.circle--warning {
  background-color: #f6cd61;
}
.circle--danger {
  background-color: var(--color-danger);
}
.circle--exported {
  background-color: var(--color-cta);
}
</style>
